import { render } from "./Typing.vue?vue&type=template&id=40ad8ca8&scoped=true"
import script from "./Typing.vue?vue&type=script&lang=js"
export * from "./Typing.vue?vue&type=script&lang=js"

import "./Typing.vue?vue&type=style&index=0&id=40ad8ca8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ad8ca8"]])

export default __exports__